import { ClientGetRoomHistory, ClientGetRoomHistoryResponse } from "../../proto/ClientGetRoomHistory_pb";
import { ClientSearchRoomHistory, ClientSearchRoomHistoryResponse } from "../../proto/ClientSearchRoomHistory_pb";
import { Room, RoomMessage } from "../../proto/Global_pb";
import { sharedMediaTypes } from "../../constants/globals";

export const ADD_ROOM_MESSAGES = "ADD_ROOM_MESSAGES";
export const REMOVE_ROOM_MESSAGE = "REMOVE_ROOM_MESSAGE";
export const REMOVE_ROOM_MESSAGES = "REMOVE_ROOM_MESSAGES";
export const EDIT_ROOM_MESSAGE = "EDIT_ROOM_MESSAGE";
export const MARK_AS_READ_MESSAGES = "MARK_AS_READ_MESSAGES";
export const CLEAR_ROOM_MESSAGES = "CLEAR_ROOM_MESSAGES";
export const UPDATE_SELECTED_MESSAGES = "UPDATE_SELECTED_MESSAGES";
export const CLEAR_SELECTED_MESSAGES = "CLEAR_SELECTED_MESSAGES";
export const ADD_ROOM_MEDIA = "ADD_ROOM_MEDIA";
export const REMOVE_ROOM_MEDIA = "REMOVE_ROOM_MEDIA";
export const ADD_MESSAGES_LOADER = "ADD_MESSAGES_LOADER";
export const REMOVE_MESSAGES_LOADER = "REMOVE_MESSAGES_LOADER";
export const REMOVE_MESSAGES_LOADERS = "REMOVE_MESSAGES_LOADERS";
export const EDIT_MESSAGES_LOADERS = "EDIT_MESSAGES_LOADERS";
export const SET_SCROLLED_MESSAGE = "SET_SCROLLED_MESSAGE";
export const SET_SHARED_MEDIA = "SET_SHARED_MEDIA";
export const RESET_SHARED_MEDIA = "RESET_SHARED_MEDIA";
export const REMOVE_FAKE_MESSAGE = "REMOVE_FAKE_MESSAGE";
export const GO_TO_MESSAGE = "GO_TO_MESSAGE";

export type MessagesType = {
  [messageId in RoomMessage.AsObject["messageId"]]: RoomMessage.AsObject & { dateLastMessage?: boolean };
};
export type RoomMessagesType = {
  [roomId in Room.AsObject["id"]]: Array<RoomMessage.AsObject["messageId"]>;
};
export type RoomSelectedMessagesType = Array<RoomMessage.AsObject["messageId"]>;
export type RoomMediaType = {
  [roomId in Room.AsObject["id"]]: {
    [filter in ClientSearchRoomHistory.FilterMap[keyof ClientSearchRoomHistory.FilterMap]]: Array<RoomMessage.AsObject["messageId"]>;
  };
};
export type MessagesLoaderType = {
  [roomId in Room.AsObject["id"]]: "init" | "processing" | "resolved";
};

export type ScrolledMessageObjectType = {
  messageId: RoomMessage.AsObject["messageId"];
  upMessageId?: RoomMessage.AsObject["messageId"];
  lastMessageInView?: boolean;
  userCalled: boolean;
};
export type ScrolledMessageType = {
  [roomId in Room.AsObject["id"]]: ScrolledMessageObjectType;
};

export type SharedMediaStoreType = {
  roomId?: Room.AsObject["id"];
  messages: {
    [mediaType in sharedMediaTypes]: Array<RoomMessage.AsObject>;
  };
};

export type RoomMessagesStateType = {
  messages: MessagesType;
  roomMessages: RoomMessagesType;
  roomSelectedMessages: RoomSelectedMessagesType;
  roomMedia: RoomMediaType;
  messagesLoader: MessagesLoaderType;
  scrolledMessage: ScrolledMessageType;
  sharedMedia: SharedMediaStoreType;
};

export type AddRoomMessagesActionType = {
  type: typeof ADD_ROOM_MESSAGES;
  payload: {
    roomId: Room.AsObject["id"];
    messageList: ClientGetRoomHistoryResponse.AsObject["messageList"];
  };
};

export type EditRoomMessageActionType = {
  type: typeof EDIT_ROOM_MESSAGE;
  payload: {
    messageId: RoomMessage.AsObject["messageId"];
    message: Partial<RoomMessage.AsObject>;
  };
};

export type MarkAsReadMessagesType = {
  type: typeof MARK_AS_READ_MESSAGES;
  payload: {
    roomId: Room.AsObject["id"];
    messageId: RoomMessage.AsObject["messageId"];
    updaterAuthorHash: string;
  };
};

export type RemoveRoomMessageActionType = {
  type: typeof REMOVE_ROOM_MESSAGE;
  payload: {
    roomId: Room.AsObject["id"];
    messageId: RoomMessage.AsObject["messageId"];
  };
};
export type RemoveRoomMessagesActionType = {
  type: typeof REMOVE_ROOM_MESSAGES;
  payload: {
    roomId: Room.AsObject["id"];
  };
};
export type ClearRoomMessagesActionType = {
  type: typeof CLEAR_ROOM_MESSAGES;
  payload: {
    roomId: Room.AsObject["id"];
    clearId: string;
  };
};
export type UpdateRoomSelectedMessagesActionType = {
  type: typeof UPDATE_SELECTED_MESSAGES;
  payload: {
    messageId: RoomMessage.AsObject["messageId"];
  };
};
export type ClearRoomSelectedMessagesActionType = {
  type: typeof CLEAR_SELECTED_MESSAGES;
};
export type AddRoomMediaActionType = {
  type: typeof ADD_ROOM_MEDIA;
  payload: {
    roomId: Room.AsObject["id"];
    mediaList: ClientSearchRoomHistoryResponse.AsObject["resultList"];
    filter: ClientSearchRoomHistory.FilterMap[keyof ClientSearchRoomHistory.FilterMap];
  };
};
export type RemoveRoomMediaActionType = {
  type: typeof REMOVE_ROOM_MEDIA;
  payload: Room.AsObject["id"];
};

export type AddMessagesLoaderActionType = {
  type: typeof ADD_MESSAGES_LOADER;
  payload: {
    roomId: Room.AsObject["id"];
    toMessageId: RoomMessage.AsObject["messageId"];
    fromMessageId: RoomMessage.AsObject["messageId"];
    direction: Array<ClientGetRoomHistory.AsObject["direction"]>;
  };
};

export type EditMessagesLoaderActionType = {
  type: typeof EDIT_MESSAGES_LOADERS;
  payload: {
    roomId: Room.AsObject["id"];
    fromMessageId: RoomMessage.AsObject["messageId"];
    direction: ClientGetRoomHistory.AsObject["direction"];
    status: "init" | "processing" | "resolved";
  };
};

export type RemoveMessagesLoaderActionType = {
  type: typeof REMOVE_MESSAGES_LOADER;
  payload: {
    roomId: Room.AsObject["id"];
    fromMessageId: RoomMessage.AsObject["messageId"];
    direction: ClientGetRoomHistory.AsObject["direction"];
  };
};

export type RemoveMessagesLoadersActionType = {
  type: typeof REMOVE_MESSAGES_LOADERS;
  payload: Room.AsObject["id"];
};

export type SetScrolledMessageActionType = {
  type: typeof SET_SCROLLED_MESSAGE;
  payload: {
    [key: string]: Partial<ScrolledMessageObjectType>;
  };
};

export type SetSharedMediaActionType = {
  type: typeof SET_SHARED_MEDIA;
  payload: { [key: string]: Array<RoomMessage.AsObject> };
};

export type ResetSharedMediaActionType = {
  type: typeof RESET_SHARED_MEDIA;
  payload: SharedMediaStoreType["roomId"];
};

export type RemoveFakeMessage = {
  type: typeof REMOVE_FAKE_MESSAGE;
  payload: { randomId: RoomMessage.AsObject["randomId"]; roomId: Room.AsObject["id"] };
};

export type GoToMessageType = {
  type: typeof GO_TO_MESSAGE;
  payload: { messageId: RoomMessage.AsObject["messageId"]; roomId: Room.AsObject["id"]; hasPriority: boolean };
};

export type MessagesActionTypes =
  | AddRoomMessagesActionType
  | EditRoomMessageActionType
  | MarkAsReadMessagesType
  | RemoveRoomMessageActionType
  | RemoveRoomMessagesActionType
  | ClearRoomMessagesActionType
  | AddRoomMediaActionType
  | RemoveRoomMediaActionType
  | UpdateRoomSelectedMessagesActionType
  | ClearRoomSelectedMessagesActionType
  | AddMessagesLoaderActionType
  | EditMessagesLoaderActionType
  | RemoveMessagesLoaderActionType
  | RemoveMessagesLoadersActionType
  | SetScrolledMessageActionType
  | SetSharedMediaActionType
  | ResetSharedMediaActionType
  | RemoveFakeMessage
  | GoToMessageType;
